module.exports = __webpack_public_path__ + "static/media/r359.35f9c7b8.jpg";